import builder from '../builder';
import RealEstateActionHouseRemove from '../../streamline-icons/bold/real-estate-action-house-remove.svg';

export default builder(
  'IconRealEstateActionHouseRemoveBold',
  RealEstateActionHouseRemove,
);
